import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { SEARCH_QUERY_KEY } from './components/PlaylistItemSearchManager';
import { PLAYLIST_RESULTS_URL_FRAGMENT } from '../../constants/Navigation';
export const usePlaylistSearchManagerOpenState = playlistId => {
  const history = useHistory();
  const {
    path
  } = useRouteMatch();
  const isPlaylistSearchManagerOpen = path === PLAYLIST_RESULTS_URL_FRAGMENT;
  const {
    playlistId: paramPlaylistId
  } = useParams();
  const openPlaylistSearchManager = searchTerm => {
    const pId = playlistId || paramPlaylistId;
    if (!pId) return;
    const search = new URLSearchParams(history.location.search);
    if (searchTerm) search.set(SEARCH_QUERY_KEY, searchTerm);
    history.push(Object.assign({}, history.location, {
      pathname: PLAYLIST_RESULTS_URL_FRAGMENT.replace(':playlistId', pId.toString()),
      search: search.toString()
    }));
  };
  return {
    isPlaylistSearchManagerOpen,
    openPlaylistSearchManager
  };
};